import {ConversionRateResponse as ConversionRateResponseServer} from '@wix/ambassador-ecommerce-currency-converter-v1-currency-rate/types';
import type {IHttpClient} from '@wix/fe-essentials/http-client';
import {ReportError} from '../viewerScript/GalleryController';
import {conversionRate as getConversionRateApi} from '@wix/ambassador-ecommerce-currency-converter-v1-currency-rate/http';
import type {ErrorHandlerPublicAPI} from '@wix/fe-essentials-viewer-platform/error-handler';

export type ConversionRateResponse = {data: ConversionRateResponseServer};

export const getConversionRate = async (
  httpClient: IHttpClient,
  reportError: ReportError,
  currency: string,
  currentCurrency: string,
  errorHandler?: ErrorHandlerPublicAPI
): Promise<ConversionRateResponse> => {
  const getConversionRateApiRequest = () =>
    httpClient.request(getConversionRateApi({from: currency, to: currentCurrency}));

  const getConversionRateApiResponse = errorHandler
    ? errorHandler.withErrorHandler(getConversionRateApiRequest, {errorCodesMap: {}})
    : /* istanbul ignore next */ getConversionRateApiRequest();

  return getConversionRateApiResponse.catch((error) => {
    reportError(error, false);
    /* istanbul ignore next: errorHandler exists in tests */
    if (errorHandler) {
      const errorMessage = errorHandler.getResolvedError(error).message;
      // eslint-disable-next-line no-console
      console.log('getConversionRateApiResponse has an error', errorMessage);
    }
    return {data: {rate: {value: '1', decimalPlaces: 0}}};
  });
};
